import {Text} from '@/ui-kits';
interface ProfileDataSectionProps {
    title: string;
    children: React.ReactNode;
  }
  export const ProfileDataSection: React.FC<ProfileDataSectionProps> = props => {
    const {title, children} = props;
    return (
      <div className="bg-white rounded-xl shadow-[0px_4px_41.6px_-13px_rgba(0,0,0,0.15)] p-3 sm:p-6">
        <Text
          variant="h2"
          className="font-FigtreeSemiBold text-ui_blue text-2xl mb-6">
          {title}
        </Text>
        {children}
      </div>
    );
  };